// client/src/pages/Game/Battlefield/components/LoadingScreen.jsx

import React from 'react';
import Loader from '../../../../components/ui/Loader';
import Button from '../../../../components/ui/Button';

/**
 * Composant pour afficher un écran de chargement ou d'erreur de connexion
 * @param {Object} props Les propriétés du composant
 * @param {String} props.error Message d'erreur éventuel
 * @param {Function} props.onRetry Fonction appelée pour réessayer
 * @param {Function} props.onCancel Fonction appelée pour annuler
 * @param {Boolean} props.isLoading Si le chargement est en cours
 * @returns {JSX.Element} Le composant LoadingScreen
 */
const LoadingScreen = ({
  error,
  onRetry,
  onCancel,
  isLoading = true
}) => {
  if (error) {
    return (
      <div className="battlefield-error">
        <h2>Erreur de connexion</h2>
        <p>{error}</p>
        <div className="error-actions">
          <Button 
            type="primary" 
            onClick={onRetry}
          >
            Réessayer
          </Button>
          <Button onClick={onCancel}>
            Retour au matchmaking
          </Button>
        </div>
      </div>
    );
  }
  
  if (isLoading) {
    return (
      <div className="battlefield-loading">
        <Loader size="large" color="primary" text="Chargement de la partie..." />
      </div>
    );
  }
  
  return (
    <div className="battlefield-loading">
      <h2>En attente de l'état du jeu...</h2>
      <div className="loading-spinner"></div>
      <Button onClick={onCancel} className="mt-3">
        Retour au matchmaking
      </Button>
    </div>
  );
};

export default LoadingScreen;